import { ISVG } from "./UrlIcon";

export const TickIcon = ({ fill, width, height }: ISVG) => {
    return (
        <svg
            width={width ?? "10"}
            height={height ?? "6"}
            viewBox="0 0 10 6"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            data-testid="tick-icon"
        >
            <path
                d="M8.41803 0.168978L3.71311 4.52706L1.63115 2.59857C1.36885 2.35561 0.959016 2.35561 0.696721 2.59857C0.434426 2.84153 0.434426 3.22115 0.696721 3.46411L3.2377 5.81778C3.36885 5.93926 3.53279 6 3.69672 6C3.86066 6 4.04098 5.93926 4.15574 5.81778L9.30328 1.04971C9.56557 0.806747 9.56557 0.427123 9.30328 0.184163C9.09016 -0.0587957 8.66393 -0.0587958 8.41803 0.168978Z"
                fill={fill ? fill : "white"}
            />
        </svg>
    );
};
